import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Layout,
  Input,
  Form,
  Drawer,
  Button,
  Select,
  DatePicker,
  message,
  Col,
  Modal,
} from "antd";
import { debounce, isEmpty } from "lodash";

import {
  contactCompanyListing,
  scopeofWorkAdd,
  countryListing,
  cityListing,
  scopeOfWorkListing,
  sectorListingParent,
} from "services/remanentCalls";
import {
  actionForAddRoto,
  actionForUpdateRoto,
} from "services/redux/Roto/action";
import {
  MinusCircleOutlined,
  PlusOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { allCompanyListing } from "services/redux/Reference/action";
import {
  tenderSubTypeListing,
  tenderTypeListing,
} from "services/redux/Reference/Tender/action";
import { quickCompanyAdd } from "services/redux/contact/companypeople/action";
import BiddingCompanyDetails from "./BiddingCompanyDetails";
import { getSubSectorListing } from "services/redux/officeresource/business/action";
import moment from "moment";
import axios from "axios";
import QuickAddCompany from "views/Contact/ContactCompanyPerson/AddQuickCompany";

const RotoTemplateAddUpdateForm = ({
  openForm,
  setOpenForm,
  updateData,
  setUpdateData,
}) => {
  const dispatch = useDispatch();
  const { Header } = Layout;
  const [form] = Form.useForm();
  const [formQuickAddCompany] = Form.useForm();
  const { Option } = Select;

  const { addRotoLoading, updateRotoLoading } = useSelector(
    (state) => state.reference
  );
  const [value, setValue] = useState("");
  const [contactCompanyListingResponse, setContactCompanyListing] = useState(
    []
  );
  const [selectedClientCompanyItem, setSelectedClientCompanyItem] = useState(
    []
  );
  // const [selectedBiddingCompanyItem, setSelectedBiddingCompanyItem] = useState(
  //   []
  // );
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [commaSeparatorNum, setCommaSeparatorNum] = useState("");

  // category
  const [typeListing, setTypeListing] = useState([]);
  const [subTypeListing, setSubTypeListing] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedCategoryItem, setSelectedCategoryItem] = useState([]);

  const [sectors, setSectors] = useState([]);
  const [subSectors, setSubSectors] = useState([]);
  const [selectedSectors, setSelectedSectors] = useState();
  const [selectedSectorsItem, setSelectedSectorsItem] = useState([]);

  const [scopeSearch, setScopeSearch] = useState("");
  const [selectedScopes, setSelectedScopes] = useState([]);
  const [scopeofWork, setScopeofWork] = useState([]);
  const [scopeTags, setScopeTags] = useState([]);
  const [selectedScope, setSelectedScope] = useState(null);
  const [compareTags, setCompareTags] = useState([]);
  const [scopeOfWorkList, setScopeOfWorkList] = useState([]);

  const { tenderTypeListingResponse, tenderSubTypeListingResponse } =
    useSelector((state) => state.tender);

  const { subSectorsListingLoading, subSectorsListingResponse } = useSelector(
    (state) => state.businessCenter
  );

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedCountryId, setSelectedCountryId] = useState(null);
  const [modalCities, setModalCities] = useState([]);
  const [isQuickAddModalVisible, setIsQuickAddModalVisible] = useState(false);
  const [initialCompanyName, setInitialCompanyName] = useState("");
  const [mailAddress, setMailAddress] = useState(""); // Define mailAddress as state
  const [selectedCompanyName, setSelectedCompanyName] = useState("");

  const { quickContactCompanyAdd, quickContactCompanyLoader } = useSelector(
    (state) => state.reference
  );

  useEffect(() => {
    if (updateData) {
      // Update each biddingCompany with companyInfoId
      const updatedBiddingCompany = updateData?.biddingCompany?.map(
        (company) => ({
          ...company,
          companyInfoId: company?.companyInfo?.map((item) => item?.id) ?? [],
        })
      );
      form.setFieldsValue({
        region: updateData?.region ?? "",
        tenderNo: updateData?.tenderNo ?? "",
        biddingCompany: updatedBiddingCompany ?? [],
        clientCompany: updateData?.clientCompany?.map((item) => item?.id) ?? [],
        projectName: updateData?.projectName ?? "",
        procurement: updateData?.procurement ?? "",
        country: updateData?.country ?? "",
        totalEquivPriceNPR: updateData?.totalEquivPriceNPR ?? "",
        sow: updateData?.sow?.split(",") ?? [],
        diffWithL1: updateData?.diffWithL1 ?? "",
        diffWithEstimate: updateData?.diffWithEstimate ?? "",
        winningBidder: updateData?.winningBidder ?? "",
        typeOfNotice: updateData?.typeOfNotice ?? "",
        sector: updateData?.sector?.map((item) => item?.id) ?? [],
        subSector: updateData?.subSector?.map((item) => item?.id) ?? [],
        category: updateData?.category?.map((item) => item?.id) ?? [],
        subCategory: updateData?.subCategory?.map((item) => item?.id) ?? [],
        biddingOpeningDate: updateData?.biddingOpeningDate
          ? moment(updateData?.biddingOpeningDate)
          : "",
        intendedToAward: updateData?.intendedToAward
          ? moment(updateData?.intendedToAward)
          : "",
        shortlistedDate: updateData?.shortlistedDate
          ? moment(updateData?.shortlistedDate)
          : "",
        noticeDate: updateData?.noticeDate
          ? moment(updateData?.noticeDate)
          : "",
      });
      // Set the selected country and fetch its cities
      if (updateData.country) {
        handleCountryChange(updateData.country);
      }
    }
  }, [updateData]);

  useEffect(() => {
    fetchCountryListing();
    fetchCityListing();
    // fetchAllSector();
    fetchClientCompanies();
    dispatch(tenderTypeListing());
    dispatch(allCompanyListing());
  }, []);

  useEffect(() => {
    if (isEmpty(value)) return;

    const timeoutId = setTimeout(
      () => fetchContactCompanyListing({ contactSearch: value }),
      800
    );
    return () => clearTimeout(timeoutId);
  }, [value]);

  useEffect(() => {
    if (!isEmpty(tenderTypeListingResponse)) {
      setTypeListing(tenderTypeListingResponse);
    }
  }, [tenderTypeListingResponse]);

  useEffect(() => {
    if (!isEmpty(tenderSubTypeListingResponse)) {
      setSubTypeListing(tenderSubTypeListingResponse);
    } else {
      setSubTypeListing([]);
    }
  }, [tenderSubTypeListingResponse]);
  useEffect(() => {
    fetchScopeOfWork();
  }, []);

  useEffect(() => {
    if (!isEmpty(subSectorsListingResponse)) {
      setSubSectors(subSectorsListingResponse);
    } else {
      setSubSectors([]);
    }
  }, [subSectorsListingResponse]);

  const addScopeofWork = async (value, option) => {
    if (isEmpty(option)) {
      const resp = await scopeofWorkAdd(value).catch((err) => {
        message.error("Failed to add this tag");
      });
    }
  };

  // subcategory
  const debouncedDispatch = useCallback(
    debounce((categoryId) => {
      dispatch(tenderSubTypeListing(categoryId));
    }, 500),
    [dispatch]
  );
  useEffect(() => {
    if (!selectedCategory?.id) return;

    debouncedDispatch(selectedCategory?.id);
  }, [selectedCategory?.id, debouncedDispatch]);

  // subsector
  const debouncedDispatchSectors = useCallback(
    debounce((categoryId) => {
      dispatch(getSubSectorListing(categoryId));
    }, 500),
    [dispatch]
  );

  useEffect(() => {
    if (!selectedSectors?.id) return;
    debouncedDispatchSectors(selectedSectors?.id);
  }, [selectedSectors?.id, debouncedDispatchSectors]);

  const handleSelectCategory = (values, option) => {
    if (option !== undefined) {
      const selectedData = {
        id: option.value,
        name: option.children,
      };
      setSelectedCategory(selectedData);
    }
  };
  useEffect(() => {
    const tags = scopeTags.map((tag) => tag.name?.toLowerCase());
    setCompareTags(tags);
  }, [scopeTags]);

  const handleSelectSectors = (values, option) => {
    const selectedData = {
      id: option.value,
      name: option.children,
    };
    setSelectedSectors(selectedData);
  };

  const saveCompanyToBackend = async (newCompany) => {
    try {
      const response = await fetch("/api/companies", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newCompany),
      });

      if (!response.ok) {
        throw new Error("Failed to save company");
      }

      return await response.json();
    } catch (error) {
      console.error("Error saving company:", error);
      throw error;
    }
  };

  const handleAddNewCompany = async (companyData) => {
    try {
      console.log("Sending data to the server:", companyData);

      const response = await dispatch(quickCompanyAdd(companyData));
      console.log("Server response:", response);

      if (response && response.data) {
        return response;
      }
      throw new Error("Failed to add company");
    } catch (error) {
      console.error("Error adding company:", error);
      throw error;
    }
  };

  const onFinish = async () => {
    let newValues = await form.validateFields();

    const clientCompanyIds = selectedClientCompanyItem.map((item) => item.id);

    if (updateData) {
      let val = {
        ...newValues,
        id: updateData?.id,
        clientCompany: clientCompanyIds,
        category: selectedCategory !== undefined ? [selectedCategory] : [],
        subCategory: selectedCategoryItem,
        sector: selectedSectors !== undefined ? [selectedSectors] : [],
        subSector: selectedSectorsItem,
        sow: newValues?.sow?.join(","),
      };

      dispatch(actionForUpdateRoto(val));
    } else {
      let val = {
        ...newValues,
        clientCompany: clientCompanyIds,
        category: [selectedCategory],
        subCategory: selectedCategoryItem,
        sector: [selectedSectors],
        subSector: selectedSectorsItem,
        sow: newValues?.sow?.join(","),
      };
      dispatch(actionForAddRoto(val));
    }
    setOpenForm({ drawer: false });
    form.resetFields();
    setUpdateData(null);
  };

  const handleCancel = () => {
    setOpenForm({ drawer: false });
    form.resetFields();
    setUpdateData(null);
  };

  const fetchContactCompanyListing = async (body) => {
    try {
      const resp = await contactCompanyListing(body);
      if (resp && resp.status === 200) {
        setContactCompanyListing(resp.data);
      }
    } catch (err) {
      message.error("Failed to fetch company listing");
    }
  };

  const fetchCountryListing = async () => {
    try {
      const resp = await countryListing();
      console.log("Country API response:", resp);

      if (resp && resp.status === 200) {
        const countriesData = Array.isArray(resp.data) ? resp.data : [];
        console.log("Countries data:", countriesData);
        setCountries(countriesData);
      } else {
        message.error("Failed to fetch countries");
      }
    } catch (err) {
      console.error("Error fetching countries:", err);
      message.error("Failed to fetch countries");
    }
  };

  const fetchCityListing = async (countryId) => {
    try {
      if (!countryId) {
        console.log("No country ID provided");
        setCities([]);
        return;
      }

      console.log("Fetching cities for country ID:", countryId);
      const resp = await cityListing({ CountryId: countryId });
      console.log("City API response:", resp);

      if (resp && resp.status === 200) {
        const citiesData = resp.data;
        console.log("Cities data:", citiesData);

        if (Array.isArray(citiesData)) {
          const validCities = citiesData.filter((city) => {
            const isValid = city && city.id && city.name && city.countryId;
            if (!isValid) {
              console.warn("Invalid city data:", city);
            }
            return isValid;
          });

          console.log("Valid cities count:", validCities.length);

          const sortedCities = [...validCities].sort((a, b) =>
            a.name.localeCompare(b.name)
          );

          console.log("First few sorted cities:", sortedCities.slice(0, 5));

          setCities(sortedCities);
          setModalCities(sortedCities);

          if (updateData?.city) {
            form.setFieldsValue({ city: updateData.city });
          }
        } else {
          console.error("Cities data is not an array:", citiesData);
          setCities([]);
          setModalCities([]);
        }
      } else {
        console.error("Invalid API response:", resp);
        setCities([]);
        setModalCities([]);
      }
    } catch (err) {
      console.error("Error fetching cities:", err);
      message.error("Failed to fetch cities");
      setCities([]);
      setModalCities([]);
    }
  };

  const fetchScopeOfWork = async () => {
    try {
      const response = await scopeOfWorkListing({ query: scopeSearch });
      if (response && response.data) {
        setScopeTags(response.data);
      }
    } catch (error) {
      message.error("Failed to fetch Scope of Work");
    }
  };

  useEffect(() => {
    if (scopeSearch) {
      fetchScopeOfWork();
    }
  }, [scopeSearch]);

  // const getClientCompaniesFromBackend = async () => {
  //   try {
  //     const response = await contactCompanyListing();
  //     if (response && response.status === 200) {
  //       return response.data;
  //     }
  //     throw new Error("Failed to fetch client companies");
  //   } catch (error) {
  //     throw error;
  //   }
  // };

  const fetchClientCompanies = async () => {
    try {
      // console.log("Fetching client companies...");
      const response = await contactCompanyListing();
      // console.log("Client companies response:", response);

      if (response && response.status === 200) {
        const companies = response.data;
        // console.log("Setting contact company listing:", companies);
        setContactCompanyListing(companies);
      } else {
        // console.error("Invalid response from contactCompanyListing:", response);
        message.error("Failed to fetch client companies");
      }
    } catch (error) {
      // console.error("Error fetching client companies:", error);
      message.error("Failed to fetch client companies");
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && scopeSearch.trim()) {
      const trimmed = scopeSearch.trim();
      const exists = scopeTags.some((tag) => tag.name === trimmed);
      if (!exists) {
        const newTag = { id: Date.now(), name: trimmed };
        setScopeTags((prevTags) => [...prevTags, newTag]);
        message.success(`"${trimmed}" has been added to the scope tags.`);
      }
    }
  };
  function info(scopeValue) {
    let data = scopeValue.replace(/\s+/g, " ").trim();
    data = data.split(" ");
    data = data.filter((val) => !compareTags.includes(val));

    Modal.confirm({
      title: `Are you sure if you want to add new Scope of Work "${data.join(
        ", "
      )}"?`,
      okText: "Yes",
      icon: <ExclamationCircleOutlined style={{ color: "red" }} />,
      cancelText: "No",
      onOk() {
        let val = data.map((item) => ({ name: item }));
        addScopeofWork(val);
        form.setFieldsValue({
          scopeOfWork: !isEmpty(form.getFieldsValue().scopeOfWork)
            ? [...form.getFieldsValue().scopeOfWork.concat(data)]
            : data,
        });
      },
    });
  }

  const fetchCities = async (countryId) => {
    try {
      if (!countryId) {
        console.warn("No countryId provided to fetchCities");
        setCities([]);
        return;
      }
      // console.log("Fetching cities for countryId:", countryId);
      const response = await cityListing({ CountryId: countryId });
      // console.log("City API response:", response);

      if (response && response.status === 200) {
        const citiesData = response.data?.items || response.data;

        if (Array.isArray(citiesData)) {
          // console.log("Cities data:", citiesData);
          setCities(citiesData);
          setModalCities(citiesData);
        } else {
          console.error("Cities data is not an array:", citiesData);
          setCities([]);
          setModalCities([]);
        }
      } else {
        console.error("Invalid API response:", response);
        setCities([]);
        setModalCities([]);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
      message.error("Failed to fetch cities");
      setCities([]);
      setModalCities([]);
    }
  };

  const QuickAddCompanyModal = ({
    visible,
    onCancel,
    onOk,
    scopeTags,
    countries,
    setScopeSearch,
    initialCompanyName,
  }) => {
    const [modalCities, setModalCities] = useState([]);
    const [modalCountryId, setModalCountryId] = useState(null);
    const [modalCityId, setModalCityId] = useState(null);
    const [modalCompanyName, setModalCompanyName] = useState("");
    const [selectedScopeOfWork, setSelectedScopeOfWork] = useState([]);
    const [isCityLoading, setIsCityLoading] = useState(false);

    useEffect(() => {
      if (visible && initialCompanyName) {
        setModalCompanyName(initialCompanyName);
      }
    }, [visible, initialCompanyName]);

    const fetchModalCities = async (countryId) => {
      try {
        setIsCityLoading(true);
        const resp = await cityListing({ CountryId: countryId });
        if (resp && resp.status === 200) {
          setModalCities(resp.data);
        }
      } catch (err) {
        message.error("Failed to fetch cities");
      } finally {
        setIsCityLoading(false);
      }
    };

    const handleSave = async () => {
      try {
        if (!modalCompanyName.trim()) {
          message.error("Company name is required");
          return;
        }

        if (!modalCountryId) {
          message.error("Country is required");
          return;
        }

        if (!modalCityId) {
          message.error("City is required");
          return;
        }

        if (!selectedScopeOfWork || selectedScopeOfWork.length === 0) {
          message.error("Please select at least one Scope of Work");
          return;
        }

        const newCompany = {
          companyName: modalCompanyName.trim(),
          contactSourceId: "BD6C360F-AEBA-4165-900F-0695D43216A6", // Replace with a valid UUID
          isQuickEntry: true,
          // mailAddress: mailAddress.trim() || "Not Provided", // Use mailAddress or fallback
          scopeOfWork: selectedScopeOfWork.join(","), // Comma-separated string
          cityId: modalCityId,
          countryId: modalCountryId,
          isActive: true,
          isFavorite: true,
          // contactCompanyPeople: [], // Move this inside the object
        };

        await onOk(newCompany);
      } catch (error) {
        console.error("Error in handleSave:", error);
        message.error(error.message || "Failed to save company");
      }
    };

    return (
      <Modal
        title="Quick Add Company"
        visible={visible}
        footer={null}
        onCancel={onCancel}
        keyboard={false}
        maskClosable={false}
      >
        <QuickAddCompany
          form={formQuickAddCompany}
          mainForm={form}
          companySearch={value}
          quickContactCompanyAdd={quickContactCompanyAdd}
          quickContactCompanyLoader={quickContactCompanyLoader}
          close={onCancel}
          setSelectedCompanyName={setSelectedCompanyName}
        />
      </Modal>
    );
  };

  const showModal = () => {
    console.log("Opening modal with company name:", scopeSearch);
    setIsQuickAddModalVisible(true);
  };

  const handleModalCancel = () => {
    setIsQuickAddModalVisible(false);
  };

  const handleQuickAddModalCancel = () => {
    setIsQuickAddModalVisible(false);
    setInitialCompanyName("");
  };

  const handleQuickAddModalOk = async (newCompany) => {
    try {
      console.log("Payload being sent to the server:", newCompany);

      const addCompanyResponse = await handleAddNewCompany(newCompany);

      if (addCompanyResponse && addCompanyResponse.data) {
        message.success("Company added successfully");

        const newCompanyData = {
          id: addCompanyResponse.data.id,
          companyName: addCompanyResponse.data.companyName,
        };

        setContactCompanyListing((prev) => [...prev, newCompanyData]);

        const currentCompanies = form.getFieldValue("clientCompany") || [];
        form.setFieldsValue({
          clientCompany: [...currentCompanies, newCompanyData.id],
        });

        // Also update selectedClientCompanyItem so the new company is included in the payload
        setSelectedClientCompanyItem((prev) => [...prev, newCompanyData]);

        setIsQuickAddModalVisible(false);
        setInitialCompanyName("");
      } else {
        throw new Error("Failed to add company: Invalid response");
      }
    } catch (error) {
      console.error("Error adding company:", error);
      message.error(error.message || "Failed to add company");
    }
  };

  const handleCountryChange = async (value) => {
    // console.log("Country selected:", value);
    // console.log("Available countries:", countries);

    const country = countries.find((c) => c.id === value);
    // console.log("Found country:", country);

    if (country) {
      console.log("Setting country ID:", country.id);
      setSelectedCountryId(country.id);
      await fetchCityListing(country.id);
      // console.log("Cities fetched:", cities);
      if (!updateData?.city) {
        form.setFieldsValue({ city: undefined });
      }
    } else {
      console.log("No country found for ID:", value);
      setSelectedCountryId(null);
      setCities([]);
      form.setFieldsValue({ city: undefined });
    }
  };

  const showQuickAddModal = (value) => {
    // console.log("Opening modal with value:", value);

    setInitialCompanyName(value);
    setIsQuickAddModalVisible(true);
  };

  return (
    <>
      <Drawer
        visible={openForm.drawer}
        width={551}
        maskClosable={false}
        className="drawer"
        closable={false}
      >
        <Header className="drawer__header">
          <h4 className="drawer__header--title">
            {`${updateData ? "Update " : "Add "}Roto`}
          </h4>
        </Header>

        <Form
          form={form}
          className="drawer-form-common-wrapper"
          onFinish={onFinish}
        >
          <div className="drawer-form-row">
            <div className="drawer-form-group">
              <Form.Item
                className="form__group"
                name="region"
                label="Region"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                rules={[
                  {
                    required: false,
                    message: "Please input region",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                className="form__group"
                name="clientCompany"
                label="Client Company"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Select
                  mode="multiple"
                  allowClear
                  size="default"
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  getPopupContainer={(trigger) => trigger.parentNode}
                  notFoundContent={
                    !isEmpty(scopeSearch) ? (
                      <Button
                        type="link"
                        onClick={(e) => {
                          e.stopPropagation();
                          showQuickAddModal(scopeSearch);
                        }}
                      >
                        Add "{scopeSearch}" as a new company
                      </Button>
                    ) : null
                  }
                  onSearch={(value) => {
                    setScopeSearch(value);
                    setValue(value);
                  }}
                  onKeyDown={(e) => {
                    if (
                      e.key === "Enter" &&
                      isEmpty(contactCompanyListingResponse) &&
                      !isEmpty(scopeSearch)
                    ) {
                      e.preventDefault(); // Prevent default behavior
                      showQuickAddModal(scopeSearch);
                    }
                  }}
                  onClear={() => {
                    setScopeSearch("");
                  }}
                  onChange={(value, option) => {
                    const selectedData = option.map((opt) => ({
                      id: opt.value,
                      name: opt.children,
                    }));
                    setSelectedClientCompanyItem(selectedData);
                  }}
                  value={form.getFieldValue("clientCompany")}
                >
                  {contactCompanyListingResponse.map((company) => (
                    <Option
                      key={company.id}
                      value={company.id}
                      label={company.companyName}
                    >
                      {company.companyName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Col>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  Bidding Company Details
                </div>
              </Col>
              <Form.List name="biddingCompany">
                {(fields, ops) => (
                  <BiddingCompanyDetails
                    fields={fields}
                    add={ops.add}
                    remove={ops.remove}
                    errors={ops.errors}
                    form={form}
                  />
                )}
              </Form.List>

              <Form.Item
                className="form__group"
                name="tenderNo"
                label="Tender No"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                rules={[
                  {
                    required: false,
                    message: "Please input Tender No",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                className="form__group"
                name="projectName"
                label="Project Name"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                rules={[
                  {
                    required: false,
                    message: "Please input Project Name",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                className="form__group"
                name="category"
                label="Category"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Select
                  allowClear
                  size="small"
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={handleSelectCategory}
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {typeListing.length > 0
                    ? typeListing?.map((type) => (
                        <Option key={type?.id} value={type?.id}>
                          {type?.tenderTypeName}
                        </Option>
                      ))
                    : updateData !== undefined &&
                      updateData?.category !== undefined &&
                      updateData?.category?.map((type) => (
                        <Option key={type?.id} value={type?.id}>
                          {type?.name}
                        </Option>
                      ))}
                </Select>
              </Form.Item>

              <Form.Item
                className="form__group"
                name="subCategory"
                label="Sub Category"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Select
                  mode="multiple"
                  allowClear
                  size="small"
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  getPopupContainer={(trigger) => trigger.parentNode}
                  onChange={(values, option) => {
                    const selectedData = option.map((option) => ({
                      id: option.value,
                      name: option.children,
                    }));
                    setSelectedCategoryItem(selectedData);
                  }}
                >
                  {subTypeListing.length > 0
                    ? subTypeListing?.map((type) => (
                        <Option key={type?.id} value={type?.id}>
                          {type?.tenderTypeName}
                        </Option>
                      ))
                    : updateData !== undefined &&
                      updateData?.subCategory !== undefined &&
                      updateData?.subCategory?.map((type) => (
                        <Option key={type?.id} value={type?.id}>
                          {type?.name}
                        </Option>
                      ))}
                </Select>
              </Form.Item>

              <Form.Item
                className="form__group"
                name="sector"
                label="Sector"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Select
                  allowClear
                  size="small"
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={handleSelectSectors}
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {sectors.length > 0
                    ? sectors?.map((data) => (
                        <Option key={data.id} value={data.id}>
                          {data.sectorName}
                        </Option>
                      ))
                    : updateData !== undefined &&
                      updateData?.sector !== undefined &&
                      updateData?.sector?.map((data) => (
                        <Option key={data?.id} value={data?.id}>
                          {data?.name}
                        </Option>
                      ))}
                </Select>
              </Form.Item>

              <Form.Item
                className="form__group"
                name="subSector"
                label="Sub Sector"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Select
                  mode="multiple"
                  allowClear
                  size="small"
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  getPopupContainer={(trigger) => trigger.parentNode}
                  onChange={(values, option) => {
                    const selectedData = option.map((option) => ({
                      id: option.value,
                      name: option.children,
                    }));
                    setSelectedSectorsItem(selectedData);
                  }}
                >
                  {subSectors.length > 0
                    ? subSectors?.map((data) => (
                        <Option key={data?.id} value={data?.id}>
                          {data?.sectorName}
                        </Option>
                      ))
                    : updateData !== undefined &&
                      updateData?.subSector !== undefined &&
                      updateData?.subSector?.map((data) => (
                        <Option key={data.id} value={data.id}>
                          {data.name}
                        </Option>
                      ))}
                </Select>
              </Form.Item>

              <Form.Item
                className="form__group"
                name="sow"
                label="Scope Of Work"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Select
                  mode="multiple"
                  allowClear
                  size="small"
                  showSearch
                  value={selectedScopes}
                  onSearch={(e) => {
                    setScopeSearch(e);
                  }}
                  onChange={(value) => {
                    setSelectedScopes(value);
                  }}
                  onClear={() => {
                    setScopeSearch("");
                  }}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  dropdownRender={(menu) => (
                    <>
                      {menu}
                      {scopeSearch &&
                        !scopeTags.some(
                          (tag) =>
                            tag?.name.toLowerCase() ===
                            scopeSearch.toLowerCase()
                        ) && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              padding: 8,
                            }}
                          >
                            <Button
                              type="link"
                              onClick={() => {
                                Modal.confirm({
                                  title: "Add New Scope of Work",
                                  content: `Are you sure you want to add "${scopeSearch}" as a new Scope of Work?`,
                                  onOk: () => {
                                    const newTag = {
                                      id: Date.now(),
                                      name: scopeSearch,
                                    };
                                    setScopeTags([...scopeTags, newTag]);
                                    setSelectedScopes([
                                      ...selectedScopes,
                                      scopeSearch,
                                    ]);
                                    setScopeSearch("");
                                    message.success(
                                      `"${scopeSearch}" has been added to Scope of Work.`
                                    );
                                  },
                                });
                              }}
                            >
                              + Create "{scopeSearch}"
                            </Button>
                          </div>
                        )}
                    </>
                  )}
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {scopeTags?.map((tag) => (
                    <Option value={tag.name} key={tag.id}>
                      {tag.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                className="form__group"
                name="procurement"
                label="Procurement"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                rules={[
                  {
                    required: false,
                    message: "Please input Procurement",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                className="form__group"
                name="country"
                label="Country"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Please select a country",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Search and select a country"
                  optionFilterProp="children"
                  onChange={handleCountryChange}
                  onSearch={(value) => {
                    console.log("Searching for:", value);
                  }}
                  filterOption={(input, option) => {
                    if (!option || !option.children) return false;
                    const searchText = input.toLowerCase();
                    const countryName = option.children.toLowerCase();
                    return countryName.includes(searchText);
                  }}
                  style={{ width: "100%" }}
                  allowClear
                  showArrow={true}
                  notFoundContent="No countries found"
                  loading={!countries || countries.length === 0}
                >
                  {countries && countries.length > 0 ? (
                    countries.map((country) => (
                      <Select.Option key={country.id} value={country.id}>
                        {country.name}
                      </Select.Option>
                    ))
                  ) : (
                    <Select.Option disabled>Loading countries...</Select.Option>
                  )}
                </Select>
              </Form.Item>
              <Form.Item
                name="city"
                label="City"
                rules={[{ required: true, message: "Please select a city" }]}
              >
                <Select
                  showSearch
                  placeholder={
                    selectedCountryId
                      ? "Search and select a city"
                      : "Please select a country first"
                  }
                  optionFilterProp="children"
                  disabled={!selectedCountryId}
                  filterOption={(input, option) => {
                    if (!option || !option.children) return false;
                    const searchText = input.toLowerCase();
                    const cityName = option.children.toLowerCase();
                    return cityName.includes(searchText);
                  }}
                  onChange={(value) => {
                    console.log("Selected city value:", value);
                    const selectedCity = cities.find(
                      (city) => city.id === value
                    );
                    console.log("Selected city details:", selectedCity);
                  }}
                  loading={!cities || cities.length === 0}
                  style={{ width: "100%" }}
                  allowClear
                  showArrow={true}
                  notFoundContent={
                    selectedCountryId
                      ? "No cities found matching your search"
                      : "Please select a country first"
                  }
                >
                  {cities && cities.length > 0 ? (
                    cities.map((city) => (
                      <Select.Option key={city.id} value={city.id}>
                        {city.name}
                      </Select.Option>
                    ))
                  ) : (
                    <Select.Option disabled>
                      {selectedCountryId
                        ? "No cities available"
                        : "Please select a country first"}
                    </Select.Option>
                  )}
                </Select>
              </Form.Item>
              <Form.Item
                className="form__group"
                name="biddingOpeningDate"
                label="Bidding Opening Date"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                rules={[
                  {
                    required: false,
                    message: "Please input biddingOpeningDate",
                  },
                ]}
              >
                <DatePicker format="YYYY/MM/DD" autoComplete="off" />
              </Form.Item>
              <Form.Item
                className="form__group"
                name="intendedToAward"
                label="Intended To Award"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                rules={[
                  {
                    required: false,
                    message: "Please input intendedToAward",
                  },
                ]}
              >
                <DatePicker format="YYYY/MM/DD" autoComplete="off" />
              </Form.Item>
              <Form.Item
                className="form__group"
                name="shortlistedDate"
                label="Short Listed Date"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                rules={[
                  {
                    required: false,
                    message: "Please input shortlistedDate",
                  },
                ]}
              >
                <DatePicker format="YYYY/MM/DD" autoComplete="off" />
              </Form.Item>
              <Form.Item
                className="form__group"
                name="noticeDate"
                label="Notice Date"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                rules={[
                  {
                    required: false,
                    message: "Please input noticeDate",
                  },
                ]}
              >
                <DatePicker format="YYYY/MM/DD" autoComplete="off" />
              </Form.Item>
              <div
                style={{
                  height: "20px",
                }}
              ></div>
            </div>
          </div>

          <div
            className="model-footer"
            style={{ justifyContent: "space-between", padding: "0 9px" }}
          >
            {openForm?.edit ? (
              <>
                <Form.Item>
                  <Button onClick={handleCancel} style={{ marginRight: "4px" }}>
                    Cancel
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={updateRotoLoading}
                  >
                    Update
                  </Button>
                </Form.Item>
              </>
            ) : (
              <>
                <span></span>
                <Form.Item>
                  <Button onClick={handleCancel} style={{ marginRight: "4px" }}>
                    Cancel
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={addRotoLoading}
                  >
                    Submit
                  </Button>
                </Form.Item>
              </>
            )}
          </div>
        </Form>
      </Drawer>

      <QuickAddCompanyModal
        visible={isQuickAddModalVisible}
        onCancel={handleQuickAddModalCancel}
        onOk={handleQuickAddModalOk} // Pass the updated handler
        scopeTags={scopeTags}
        countries={countries}
        setScopeSearch={setScopeSearch}
        initialCompanyName={initialCompanyName}
      />
    </>
  );
};

export default RotoTemplateAddUpdateForm;
